export const MarketGroupPhase = {
    Inplay: 'inplay',
    Prematch: 'prematch',
} as const;
export type MarketGroupPhase = typeof MarketGroupPhase[keyof typeof MarketGroupPhase];

export type SportDateWithActiveOffer = {
    _id: {
        date: string;
        sportId: number;
    }
    count: number;
};
